// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { isGuestSelector } from '../../../user/currentUserSelector';

// Components
import GuestBoardPermissionToast from './GuestBoardPermissionToast';
import UserBoardPermissionToast from './UserBoardPermissionToast';

// Styles
import './BoardPermissionToast.scss';

const BoardPermissionToast: React.FC = () => {
    const isGuest = useSelector(isGuestSelector);

    return isGuest ? <GuestBoardPermissionToast /> : <UserBoardPermissionToast />;
};

export default BoardPermissionToast;
